export const formatValues = ['png', 'jpg', 'pdf'];

export const imageSetValues = ['PV', 'SV', 'LA', 'LAPV', 'LASV', 'PHPV', 'PHSV'];

export const placeholderValue = ['spil'];
